//import { Image } from "./image";
import React from "react";
import LinkHandler from "./LinkHandler";
import { ReactCompareSlider, ReactCompareSliderImage } from 'react-compare-slider';

export const Portfolio = (props) => {
  return (
    <div className="portfolio text-center">
      <div className="container">
        <div className="section-title">
          <h2>Результаты наших работ</h2>
          <h3>Удаление повреждений лифтовых кабин и порталов</h3>
          <p>В этом разделе вы можете увидеть примеры выполненных нами проектов по <strong>восстановлению</strong> и <strong>реставрации лифтовых кабин</strong> и <strong>порталов</strong>. <LinkHandler href="/" title="Пролистать на главную (на самый верх)">Наша компания</LinkHandler> специализируется на устранении различных повреждений, таких как глубокие <strong>царапины</strong>, <strong>ржавчина</strong>, <strong>химические ожоги</strong>, <strong>затёртости</strong> и прочих дефектов. Каждая работа – это индивидуальный подход, использование профессионального оборудования и технологий.</p>
          <p>Вы можете <strong>сравнить состояние лифтов</strong> до ремонта и после, а также ознакомиться с <LinkHandler href="/customer-reviews" title="Пролистать к разделу с отзывами">отзывами</LinkHandler> клиентов, которые подтверждают высокий уровень нашей работы. Наши специалисты возвращают лифтам презентабельный внешний вид, продлевая срок их службы и сохраняя эстетическое восприятие.</p>
          <p>Убедитесь сами: ниже представлены фотографии <strong>«До»</strong> и <strong>«После»</strong> с описанием выполненных действий. Эти проекты выполнены в разных объектах <strong>Санкт-Петербурга</strong>, включая бизнес-центры, жилые дома и коммерческие помещения.</p>
        </div>
        <div className="row">
          <div className="portfolio-items">
            {props.data
              ? props.data.map((d, i) => (
                  <div
                    key={`${d.id}-${i}`}
                    className="col-sm-6 col-md-4 col-lg-4" id={d.id}
                  >
                    <ReactCompareSlider
                      itemOne={<ReactCompareSliderImage src={d.beforeImage} srcSet={d.beforeImage} alt={`${d.altBefore}`} />}
                      itemTwo={<ReactCompareSliderImage src={d.afterImage} srcSet={d.afterImage} alt={`${d.altAfter}`} />}
                      onlyHandleDraggable={true}
                    />
                    <p>{d.title}</p>
                  </div>
                ))
              : "Загрузка..."}
          </div>
        </div>
      </div>
    </div>
  );
};
